import React from "react";
import styles from "./AnnouncementsCard.module.css";
import Action from "../Action/Action";
import { FiClock } from "react-icons/fi";
import { AiOutlineHeart, AiOutlineEye } from "react-icons/ai";
import { BiMessageRoundedDots } from "react-icons/bi";
import { IoCloseOutline } from "react-icons/io5";

const AnnouncementsCard = ({
  id,
  title = "Staff Announcement",
  description,
  tagged = [],
  image,
  time,
  date,
  onRemoveTag,
  onActionSelect = () => {},
}) => {
  return (
    <div className={styles.card}>
      {/* Header */}
      <div className={styles.header}>
        <span className={styles.title}>{title}</span>
        <Action
          options={["Edit", "Delete"]}
          onSelect={(action) => onActionSelect(action, id)}
        />
      </div>

      {/* Content */}
      <div className={styles.separator}>
        <div className={styles.content}>
          <img src={image} alt="announcement" className={styles.image} />
          <div className={styles.textBlock}>
            <h4 className={styles.announcementTitle}>Announcements</h4>
            <p className={styles.description}>{description}</p>
          </div>
        </div>

        {/* Tagged Staff */}
        <div className={styles.section}>
          <label>Staff Tagged</label>
          <div className={styles.taggedBox}>
            {tagged.map((person, index) => (
              <span key={index} className={styles.tag}>
                {person}
                <IoCloseOutline
                  size={16}
                  className={styles.removeIcon}
                  onClick={() => onRemoveTag?.(id, person)}
                />
              </span>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className={styles.footer}>
          <div className={styles.stats}>
            <span>
              <AiOutlineHeart /> 0
            </span>
            <span>
              <AiOutlineEye /> 0
            </span>
            <span>
              <BiMessageRoundedDots /> 1
            </span>
          </div>
          <span className={styles.time}>
            <FiClock size={14} /> {time} • {date}
          </span>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementsCard;
